import { Box, TypographyStylesProvider, Image } from "@mantine/core";
import React from "react";
import { IconDatabase } from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import { JsonView, allExpanded, darkStyles } from "react-json-view-lite"; // Add the missing imports
import SimpleImage from "../articlesHelpers/SimpleImage";

export const USE_RIZFUL_WITH_ALBY_BROWSER_EXTENSION = (
  <TypographyStylesProvider>
    <p>
      Rizful works well as the "back end" for the{" "}
      <img
        src="https://daxwktpz4hkwd.cloudfront.net/docs_images/alby-logo.png"
        alt="Nostr Wallet Connect Icon"
        style={{ height: "1em", verticalAlign: "middle" }}
      />{" "}
      Alby Browser Extension. Let's walk through the process of setting it up.
    </p>

    <p>
      We need to grab a <code>NWC Send & Receive Connection</code> code from
      Rizful to use with the Alby Browser Extension.
    </p>
    <p>
      1. Follow{" "}
      <a
        href="/docs/connecting-apps#nostr-wallet-connect-send-and-receive"
        target="_blank"
      >
        these instructions
      </a>{" "}
      to get a NWC Send & Receive Connection Code.{" "}
    </p>
    <p>
      You'll get a code that starts with{" "}
      <code> nostr+walletconnect://p&9...</code>
    </p>

    <p>
      2. You're going to need to paste this code into the Alby Browser
      Extension.
    </p>
    <p>
      3. Install the{" "}
      <a
        href="https://chromewebstore.google.com/detail/alby-bitcoin-wallet-for-l/iokeahhehimjnekafflcihljlcjccdbe?hl=enAlby"
        target="_blank"
      >
        Alby Chrome Extension
      </a>{" "}
    </p>
    <p>4. Choose "Find Your Wallet"</p>
    <SimpleImage src="docs_images/alby-find-your-wallet.png" h={320} />

    <p>5. Choose "Nostr Wallet Connect"</p>
    <SimpleImage
      src="docs_images/alby-choose-nostr-wallet-connect.png"
      h={320}
    />

    <p>
      6. Paste Your NWC code, which looks like{" "}
      <code> nostr+walletconnect://p&9...</code> into the box.
    </p>
    <SimpleImage src="docs_images/paste-in-nwc-code.png" h={320} />

    <p>
      7. You should now seem some sats, and transactions (if you've made any.)
      Currently I'm rolling dirty with 249,646 sats.
    </p>
    <SimpleImage
      src="docs_images/you-should-now-see-some-sats-in-your-alby-extension.png"
      h={320}
    />
    <p>
      {" "}
      You now should be able to spend and receive sats with Alby. Continue on if
      you also want your Rizful node to provide your Nostr identity.
    </p>

    <h4>Optional: Use Rizful's Nostr Identity</h4>
    <p>
      8. Follow{" "}
      <a href="/docs/connecting-apps#get-nostr-private-key" target="_blank">
        these instructions
      </a>{" "}
      to get your Nostr private key.
    </p>
    <p>
      You'll get a code that starts with <code> nsec1...</code>
    </p>
    <p>9. In the extension, Go to "Wallet Settings"...</p>

    <SimpleImage src="docs_images/go-to-wallet-settings.png" h={150} />
    <p>10. Then "Nostr Settings"...</p>
    <SimpleImage src="docs_images/nostr-settings-alby.png" h={150} />
    <p>11. "Remove Current Keys"...</p>
    <SimpleImage src="docs_images/remove-current-keys.png" h={350} />
    <p>
      12. Then paste the Nostr Private Key (the code that starts with{" "}
      <code> nsec1...</code>) here.
    </p>

    <SimpleImage src="docs_images/paste-in-nostr-private-key.png" h={320} />

    <p>
      {" "}
      All done! Your Rizful node is now connected to the Alby Browser Extension.
    </p>
  </TypographyStylesProvider>
);
